import VueSanitize from 'vue-sanitize'
import Vue from 'vue'

const defaultOptions = {
  allowedTags: ['br'],
}
Vue.use(VueSanitize, defaultOptions)
